// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Wtw2H_q5pL8Azdnz {
	display: flex;
	flex-direction: column;
	gap: var(--lok-spacing-5);
	flex: 1;
}

.eQis1bQ09kZTny1v {
	display: flex;
	justify-content: center;
    flex-direction: column;
    gap: var(--lok-spacing-8);

	container-type: inline-size;
}

.YYV8q1bs4srYwntp {
	display: grid;
	gap: var(--lok-spacing-5);
	grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
	align-content: start;
	width: 100%;

    &.geGVomLFurQNNRKi > * {
        max-width: 50%;
    }
}

.dmj81PBBIADDEQ6w {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: var(--lok-spacing-2);

	font: var(--lok-typography-body-small-default);
	/* total of spacing-7 on top and bottom, taking into account the flex gap with sibling */
	padding-block: var(--lok-spacing-3) var(--lok-spacing-7);

	& a {
		text-decoration: underline;
		color: var(--lok-color-text-light-default);
	}

	& a:hover {
		color: var(--lok-color-text-default);
	}
}
`, "",{"version":3,"sources":["webpack://./packages/rag/src/components/LandingPage/LandingPage.module.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,sBAAsB;CACtB,yBAAyB;CACzB,OAAO;AACR;;AAEA;CACC,aAAa;CACb,uBAAuB;IACpB,sBAAsB;IACtB,yBAAyB;;CAE5B,2BAA2B;AAC5B;;AAEA;CACC,aAAa;CACb,yBAAyB;CACzB,2DAA2D;CAC3D,oBAAoB;CACpB,WAAW;;IAER;QACI,cAAc;IAClB;AACJ;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,mBAAmB;CACnB,yBAAyB;;CAEzB,8CAA8C;CAC9C,wFAAwF;CACxF,wDAAwD;;CAExD;EACC,0BAA0B;EAC1B,0CAA0C;CAC3C;;CAEA;EACC,oCAAoC;CACrC;AACD","sourcesContent":[".container {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: var(--lok-spacing-5);\n\tflex: 1;\n}\n\n.cardsContainer {\n\tdisplay: flex;\n\tjustify-content: center;\n    flex-direction: column;\n    gap: var(--lok-spacing-8);\n\n\tcontainer-type: inline-size;\n}\n\n.contents {\n\tdisplay: grid;\n\tgap: var(--lok-spacing-5);\n\tgrid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\n\talign-content: start;\n\twidth: 100%;\n\n    &.singleCard > * {\n        max-width: 50%;\n    }\n}\n\n.disclaimer {\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n\tgap: var(--lok-spacing-2);\n\n\tfont: var(--lok-typography-body-small-default);\n\t/* total of spacing-7 on top and bottom, taking into account the flex gap with sibling */\n\tpadding-block: var(--lok-spacing-3) var(--lok-spacing-7);\n\n\t& a {\n\t\ttext-decoration: underline;\n\t\tcolor: var(--lok-color-text-light-default);\n\t}\n\n\t& a:hover {\n\t\tcolor: var(--lok-color-text-default);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Wtw2H_q5pL8Azdnz`,
	"cardsContainer": `eQis1bQ09kZTny1v`,
	"contents": `YYV8q1bs4srYwntp`,
	"singleCard": `geGVomLFurQNNRKi`,
	"disclaimer": `dmj81PBBIADDEQ6w`
};
export default ___CSS_LOADER_EXPORT___;
